// extracted by mini-css-extract-plugin
module.exports = {"oddEvenCard":"cr_hX","coverImageSection":"cr_hc","even":"cr_g9","odd":"cr_hb","coverImage":"cr_dt","descriptionSection":"cr_fx","title":"cr_S"};